module.exports = __webpack_public_path__ + "img/visit.342dbff8.svg";